export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';
